import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import NumberFormat from 'react-number-format';
import { IMG_URL } from '../../config/apiURL';

class CartItem extends Component {
   constructor(props) {
      super(props);
      this.state = {
         cantidad: this.props.item.cantidad,
      };
   }

   handleChange(item, event) {
      const cart = this.props.carrito;
      const limit = item.Unidad === 'Kg' ? 0 : 1;
      const cantidad = parseFloat(event.target.value);
      if (cantidad >= limit) {
         // Asigna la cantidad al producto en el array de Carrito
         Object.assign(
            cart.find(prod => prod.id_producto === item.id_producto),
            { cantidad: cantidad }
         );

         this.setState({ cantidad: cantidad });
         this.props.dispatch(action.upd_carrito(cart, item));
      }
   }

   validate(item, event) {
      const cart = this.props.carrito;
      const cantidad = parseFloat(event.target.value);
      if (cantidad < 0.01) {
         // Asigna la cantidad al producto en el array de Carrito
         Object.assign(
            cart.find(prod => prod.id_producto === item.id_producto),
            { cantidad: 1 }
         );

         this.setState({ cantidad: 1 });
         this.props.dispatch(action.upd_carrito(cart, item));
      }
   }

   removeProd(id) {
      this.props.dispatch(action.removeProd(id));
   }

   render() {
      const item = this.props.item;
      const cantidad = this.props.item.cantidad;
      const precio = this.props.item.Precio;
      const total = cantidad * precio;

      return (
         <tr className="table-row">
            <td className="table-img bordered">
               <div className="responsive-img">
                  <img
                     src={
                        IMG_URL +
                        '/catalogo/obtenerimagenes?id_producto=' +
                        item.id_producto
                     }
                     alt="Producto en carrito"
                     title="Producto en carrito"
                  />
               </div>
            </td>
            <td className="nombre-producto bordered">{item.Producto}</td>
            <td className="unidad bordered">{item.Unidad}</td>
            <td className="cantidad bordered">
               <input
                  className="input-text"
                  type="number"
                  step="any"
                  placeholder="Cantidad"
                  name="cantidad"
                  id="cantidad"
                  value={this.state.cantidad}
                  onChange={this.handleChange.bind(this, item)}
                  min="0"
                  onBlur={this.validate.bind(this, item)}
               />
            </td>
            <td className="precio-unitario bordered">
               <NumberFormat
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix="$"
                  value={item.Precio}
                  thousandSeparator={true}
               />
            </td>
            <td className="precio-total bordered">
               <NumberFormat
                  decimalScale={2}
                  displayType="text"
                  fixedDecimalScale={true}
                  prefix="$"
                  value={total}
                  thousandSeparator={true}
               />
            </td>
            <td className="delete bordered">
               {/*<button className="btn btn-danger color-white" onClick={this.removeProd.bind(this, item.id_producto)}>X</button>*/}
               <a onClick={this.removeProd.bind(this, item.id_producto)}>
                  <i className="fas fa-trash-alt"></i>
               </a>
            </td>
         </tr>
      );
   }
}

function mapStateToProps(state) {
   return {
      carrito: state.carrito,
      count: state.carrito_count,
   };
}

export default connect(mapStateToProps)(CartItem);



// WEBPACK FOOTER //
// ./src/components/Cart/cartItem.js